module.exports = __webpack_public_path__ + "static/media/education.9a9952d7.png";